import axios from "axios";
import Qs from "qs";

const axiosInstance = axios.create({
  paramsSerializer: function (params) {
    return Qs.stringify(params, { arrayFormat: "brackets" });
  },
});

axiosInstance.interceptors.request.use(async (config) => {
  // Skip for safe methods or the /csrf endpoint itself
  if (["GET", "HEAD", "OPTIONS"].includes(config.method.toUpperCase()) || config.url === "/csrf") {
    return config;
  }

  // Fetch fresh token
  try {
    const { data } = await axiosInstance.get("/csrf", { withCredentials: true }); // Sends cookies for auth
    config.headers["csrf-token"] = data.csrfToken; // Or 'X-CSRF-Token' if csurf expects that
  } catch (err) {
    console.error("Failed to fetch CSRF token:", err);
  }

  return config;
});

// Add a request interceptor
axiosInstance.interceptors.request.use(
  (config) => {
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Add a response interceptor
axiosInstance.interceptors.response.use((response) => {
  return response;
}, responseErrorHandler);

// handle errors
function responseErrorHandler(error) {
  if (error.response) {
    return responseErrorStatusHandler(error);
  } else {
    return timeoutHandler(error);
  }
}

// handle timeout
function timeoutHandler(error) {
  return Promise.reject(error);
}

// handle error response
function responseErrorStatusHandler(error) {
  const response = error.response;

  switch (response.status) {
    case 401:
      return unAuthorizedHandler(error);
    default:
      break;
  }

  return Promise.reject(error);
}

// handle unauthorized response
function unAuthorizedHandler(error) {
  const response = error.response;
  let authHeader = response.headers["www-authenticate"];

  if (authHeader) {
    let [authScheme] = authHeader.split(" ");
    if (authScheme === "EKSessReload") {
      window.location.reload();
    }
  }

  return Promise.reject(error);
}

export default axiosInstance;
